import React from 'react';

function UnitOverview({ data }) {
  const { unit, missions, keyTopics, compliance } = data;

  const totalMissionScore = missions.reduce((sum, m) => sum + m.missionScore, 0);
  const keyMissions = missions.filter(m => m.isKey);

  return (
    <div className="unit-overview">
      {/* 단원 기본 정보 */}
      <div className="overview-section">
        <h2>📊 {unit.name} 개요</h2>
        <div className="overview-grid">
          <div className="overview-card">
            <div className="value">{unit.totalStudents?.toLocaleString()}</div>
            <div className="label">분석 학생 수</div>
          </div>
          <div className="overview-card">
            <div className="value">{unit.totalItems}</div>
            <div className="label">총 문항 수</div>
          </div>
          <div className="overview-card">
            <div className="value">{unit.overallAccuracy}</div>
            <div className="label">전체 정답률</div>
          </div>
          <div className="overview-card">
            <div className="value">{missions.length}</div>
            <div className="label">학습 미션</div>
          </div>
          <div className="overview-card">
            <div className="value" style={{ color: '#FF6B6B' }}>{keyMissions.length}</div>
            <div className="label">핵심 미션</div>
          </div>
          <div className="overview-card">
            <div className="value" style={{ color: '#FFA000' }}>{totalMissionScore}</div>
            <div className="label">최대 점수</div>
          </div>
        </div>
      </div>

      {/* Key 토픽 랭킹 */}
      <div className="overview-section">
        <h3>🏆 토픽별 단원평가 영향력</h3>
        <p style={{ fontSize: '0.85rem', color: '#718096', marginBottom: 16 }}>
          상관계수가 높을수록 단원 이해에 중요한 토픽이에요.
        </p>

        {keyTopics.map((topic, idx) => {
          const pct = Math.max(0, Math.round(topic.correlation * 100));
          const isKey = topic.correlation > 0.45;

          return (
            <div key={idx} style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                  {isKey && '🔑 '}{topic.topic}
                </span>
                <span style={{
                  fontSize: '0.85rem', fontWeight: 700,
                  color: topic.correlation > 0.5 ? '#D32F2F' : topic.correlation > 0.3 ? '#F57F17' : '#2E7D32'
                }}>
                  {(topic.correlation * 100).toFixed(0)}%
                </span>
              </div>
              <div style={{
                height: 10, background: '#E8ECEF', borderRadius: 5, overflow: 'hidden'
              }}>
                <div style={{
                  width: `${pct}%`, height: '100%', borderRadius: 5,
                  background: topic.correlation > 0.5 ? 'linear-gradient(90deg, #EF5350, #FF8A80)' :
                              topic.correlation > 0.3 ? 'linear-gradient(90deg, #FFA726, #FFD54F)' :
                              'linear-gradient(90deg, #66BB6A, #A5D6A7)',
                }} />
              </div>
              {topic.gap != null && (
                <div style={{ fontSize: '0.75rem', color: '#718096', marginTop: 2 }}>
                  상위 학생 {(topic.highToFinal * 100)?.toFixed(0)}% vs 하위 학생 {(topic.lowToFinal * 100)?.toFixed(0)}%
                  (차이 {(topic.gap * 100).toFixed(1)}%p)
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* 풀이 순서 준수율 */}
      {compliance && Object.keys(compliance).length > 0 && (
        <div className="overview-section">
          <h3>📋 풀이 순서 준수율</h3>
          <p style={{ fontSize: '0.85rem', color: '#718096', marginBottom: 12 }}>
            진단 → 형성 → 단원 순서대로 학습한 비율
          </p>

          {[
            { label: '진단→형성', key: '진단→형성 준수율' },
            { label: '형성→단원', key: '형성→단원 준수율' },
            { label: '전체 순서', key: '전체 준수율' },
          ].map(({ label, key }) => {
            const rate = compliance[key];
            if (rate == null) return null;
            const pct = Math.round(rate * 100);

            return (
              <div key={key} className="compliance-bar">
                <span className="compliance-label">{label}</span>
                <div className="compliance-track">
                  <div
                    className="compliance-fill"
                    style={{
                      width: `${pct}%`,
                      background: pct > 80 ? '#4CAF50' : pct > 50 ? '#FFA726' : '#EF5350',
                    }}
                  >
                    {pct}%
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UnitOverview;
